import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { parseShortDateWithTime } from '../../../../utils/dates';

export default function ReferralServiceDetails({ entity, entityName, isService }) {
  return (
    <div className="clinician-info-box">
      <div>
        <Typography variant="h6" gutterBottom>
          {`${entityName} Details`}
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Name" />
            <span className="divider" />
            <ListItemText secondary={entity.name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Is Active" />
            <span className="divider" />
            <ListItemText secondary={entity.isActive ? 'Yes' : 'No'} />
          </ListItem>
          {isService && (
            <ListItem>
              <ListItemText primary="End Date" />
              <span className="divider" />
              <ListItemText secondary={parseShortDateWithTime(entity.endDate)} />
            </ListItem>
          )}
        </List>
      </div>
    </div>
  );
}
